import React from "react";

const SuccessBanner = require("./images/shield-green.svg");
const AlertIcon = require("../../../assets/images/icons/alert-triangle-yellow.svg");

export default class MFASetupSuccess extends React.Component {
  render(): JSX.Element {
    return (
      <>
        <img src={SuccessBanner} alt="Shield with celebration" />
        <p className="mb-3 fs-lg" data-testid="setup-success">
          You have completed the Multi-Factor Authentication setup. Your account
          security is now stronger than ever. Way to go!{" "}
          <span aria-label="Celebration" role="img">
            🎉
          </span>
        </p>

        <div className="banner is-warning is-flex gap-2">
          <div className="banner-icon mfa-setup-success__icon">
            <img src={AlertIcon} alt="Exclamation point in a triangle" />
          </div>

          <div className="banner-content">
            Going forward, you will need your authenticator app&apos;s unique
            6-digit code to login to Bonusly.
          </div>
        </div>
      </>
    );
  }
}
